import { Component, Input, OnInit, ViewEncapsulation, Injector, ElementRef, QueryList, ViewChild, ViewChildren } from '@angular/core'
import { AbstractComponent } from "../abstract.component";
import { Module, TextPosition } from "../../model/ModuleModel";
import { UpaTarget } from '../../services/upa.service';
import { HeadlessModuleService } from '../../services/headlessModules.service';
import { ScreenType } from 'projects/common/model/ScreenType';
import { EmtpyStateService } from 'projects/common/services/empty-state.service';
import { ButtonOptions } from '../eva-button/eva-button.component';

type Tab = {
  title_tab: string;
  modules: Module[];
  ajax?: boolean;
  module_ids?: string[]; // solo necesario si ajax es true, para identificar qué módulos cargar
}

enum ViewType {
  TABS = 'TABS',
  ACCORDION = 'ACCORDION',
  TABS_FULL_WIDTH = 'TABS_FULL_WIDTH',
  TAGS = 'TAGS'
}

type GroupedModulesOptions = {
  variant?: 'DEFAULT' | 'LIGHTEN' | 'LINK';
  accordion_icon?: string;
  show_accordion_icon?: boolean;
  accordion_icon_color?: string;
  accordion_full_rounded?: boolean;
};

type Tabs = {
  tabs: Tab[];
  view_type?: ViewType
  selected_tab_index?: number;
  trip_planner_id?: string;
  lina_id?: string;
  options?: GroupedModulesOptions;
}

type TabSelected = {
  name: string;
  index: number;
}

declare var window: any;

@Component({
  selector: 'grouped-modules',
  template: `
  <text-layout
    [textPosition]="textPosition"
    [screenType]="screenType"
    [isFullWidth]="isFullWidth"
    [module]="module"
  >
    <div class="{{module.data.view_type}}">
        <eva-tabs *ngIf="module.data.view_type === viewType.TABS || !module.data.view_type || isFullWidth" [product]="'nymeria-gui'" [flow]="flow" (tabSelected)="tabSelected($event)" [isStickyHeader]="true">
          <eva-tab *ngFor="let tabComponent of module.data.tabs;let i = index" [title]="tabComponent.title_tab" [active]="i === openPanelIndex">
            <ng-container *ngIf="tabComponent.ajax; else notLazyTab">
              <ng-container *ngIf="!loadingModules[i]; else loading">
                <meta-component *ngFor="let tabModule of ajaxModulesByTab[i]"
                                [module]="tabModule"
                                [currency]="currency"
                                [device]="device"
                                [flow]="flow"
                                [product]="product"
                                [containerId]="getContainerId(i)">
                </meta-component>
              </ng-container>
              <ng-template #loading>
                <skeleton></skeleton>
              </ng-template>
            </ng-container>
            <ng-template #notLazyTab>
              <div *ngIf="!hasSomeAjaxModule(tabComponent.modules)">
                  <meta-component *ngFor="let tabModule of tabComponent.modules;" [module]="tabModule" [currency]="currency"
                    [device]="device" [flow]="flow" [product]="product" [containerId]="getContainerId(i)">
                  </meta-component>
              </div>
              <div *ngIf="hasSomeAjaxModule(tabComponent.modules)">
                  <ng-container *ngIf="!loadingModules[i]; else loading">
                    <meta-component *ngFor="let tabModule of ajaxModulesByTab[i]"
                                    [module]="tabModule"
                                    [currency]="currency"
                                    [device]="device"
                                    [flow]="flow"
                                    [product]="product"
                                    [containerId]="getContainerId(i)">
                    </meta-component>
                  </ng-container>
                  <ng-template #loading>
                    <skeleton></skeleton>
                  </ng-template>
              </div>
            </ng-template>
          </eva-tab>
        </eva-tabs>
        <div *ngIf="module.data.view_type === viewType.ACCORDION" class="accordion-container" [ngClass]="{'-full-rounded': isFullRoundedAccordion }">
          <ng-container *ngFor="let tabComponent of module.data.tabs; let i = index">
            <div class="accordion-header" 
              [ngClass]="{
                'header-first-item': i === 0, 
                'header-last-item': i === module.data.tabs.length -1, 
                '-active': openPanelIndex === i,
                '-rounded-top': isFullRoundedAccordion
              }"
              (click)="accordionSelected(i)"
              >
            <div class="icon-wrapper" >
              <i *ngIf="showAccordionIcon"
                [class]="accordionIconClass + ' -eva-3-icon-md accordion-left-icon'"
                [ngStyle]="{ color: module.data.options?.accordion_icon_color }"
                >
              </i>  
              <span [ngClass]="{ 
                'eva-3-h4': screenType === ScreenType.DESKTOP, 
                'eva-3-h5': screenType !== ScreenType.DESKTOP 
              }">
                {{tabComponent.title_tab}}
              </span>
            </div>  
              <i [ngClass]="{'eva-3-icon-chevron-up': openPanelIndex === i, 'eva-3-icon-chevron-down': openPanelIndex !== i }" class="-eva-3-icon-xsm accordion-icon"></i>
            </div>
            <div class="accordion-content" 
              *ngIf="openPanelIndex === i"
              [ngClass]="{'-rounded-bottom': isFullRoundedAccordion}"
              >
              <ng-container *ngIf="tabComponent.ajax; else notLazyAccordion">
                <ng-container *ngIf="!loadingModules[i]; else loadingAccordion">
                  <meta-component *ngFor="let tabModule of ajaxModulesByTab[i]"
                                  [module]="tabModule" [currency]="currency"
                                  [device]="device" [flow]="flow" [product]="product" [containerId]="getContainerId(i)">
                  </meta-component>
                </ng-container>
                <ng-template #loadingAccordion>
                  <skeleton></skeleton>
                </ng-template>
              </ng-container>
              <ng-template #notLazyAccordion>
                <meta-component *ngFor="let tabModule of tabComponent.modules;" [module]="tabModule" [currency]="currency"
                                [device]="device" [flow]="flow" [product]="product" [containerId]="getContainerId(i)">  
                </meta-component>
              </ng-template>
            </div>
          </ng-container>
        </div>
          <div *ngIf="module.data.view_type === viewType.TAGS" 
            class="eva-tags-switcher" 
            [ngClass]="{'module-layout--no-bg': !hasBackground && isDesktop }"
          >
            <div class="eva-tags-list" #tagsList>
              <div
                *ngFor="let tag of module.data.tabs; let i = index"
                #tagItem
                class="eva-tags-item"
                [ngClass]="{
                  '-active': i === selectedIndex,
                  '-variant-default': (module.data.options?.variant ?? 'DEFAULT') === 'DEFAULT',
                  '-variant-lighten': module.data.options?.variant === 'LIGHTEN',
                  '-variant-link': module.data.options?.variant === 'LINK'
                }"
              >
                <eva-button
                  [moduleId]="module.id"
                  [uniqueId]="module.unique_id"
                  [moduleIndex]="module.position"
                  [position]="i"
                  [disableHref]="true"
                  [options]="buildTagButtonOptions(tag.title_tab, i === selectedIndex)"
                  (clickEvent)="tagSelected(i)">
                </eva-button>
              </div>
            </div>
            <div class="eva-tags-content">
              <ng-container *ngIf="module.data.tabs[selectedIndex]?.ajax; else notLazyTags">
                <ng-container *ngIf="!loadingModules[selectedIndex]; else loadingTags">
                  <meta-component *ngFor="let tabModule of ajaxModulesByTab[selectedIndex]"
                    [module]="tabModule"
                    [currency]="currency"
                    [device]="device"
                    [flow]="flow"
                    [product]="product"
                    [containerId]="getContainerId(selectedIndex)">
                  </meta-component>
                </ng-container>
                <ng-template #loadingTags>
                  <skeleton></skeleton>
                </ng-template>
              </ng-container>
              <ng-template #notLazyTags>
                <meta-component *ngFor="let tabModule of module.data.tabs[selectedIndex]?.modules"
                  [module]="tabModule"
                  [currency]="currency"
                  [device]="device"
                  [flow]="flow"
                  [product]="product"
                  [containerId]="getContainerId(selectedIndex)">
                </meta-component>
              </ng-template>
            </div>
          </div>
        </div>
  </text-layout>
  `,
  styleUrls: ['./grouped-modules.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GroupedModulesComponent extends AbstractComponent implements OnInit {
  private static MODULE_ID: string = "GroupedModules";
  @Input() override module: Module<Tabs>;
  @Input() currency;
  @Input() device;
  @Input() offersModules;
  @Input() interlinksModules;
  @Input() faqsModules;
  @Input() override flow: string;
  @Input() locale;

  openPanelIndex: number | null = 0;
  viewType = ViewType;
  isFullWidth: boolean = false;
  loadingModules: { [key: number]: boolean } = {};
  ajaxModulesByTab: { [key: number]: Module[] } = {};
  selectedIndex = 0;
  textPosition: TextPosition;
  hasBackground = false;
  ScreenType = ScreenType;
  showAccordionIcon: boolean = false;
  accordionIconClass: string | null = null;
  isFullRoundedAccordion: boolean = false;

  @ViewChild('tagsList') tagsListRef?: ElementRef<HTMLElement>;
  @ViewChildren('tagItem', { read: ElementRef }) tagItemRefs?: QueryList<ElementRef<HTMLElement>>;

  constructor(injector: Injector, private headlessModuleService: HeadlessModuleService, private emptyStateService: EmtpyStateService) {
    super(injector);
  }

  getModuleId(): string {
    return GroupedModulesComponent.MODULE_ID;
  }

  ngOnInit(): void {
    this.openPanelIndex = this.resolveOpenPanelIndex();
    this.isFullWidth = this.module.data.view_type === ViewType.TABS_FULL_WIDTH;

    const options = this.module.data.options;

    const show = !!options?.show_accordion_icon;
    const icon = options?.accordion_icon;
    const isFullRounded = !!options?.accordion_full_rounded;

    if (this.module.data.view_type === ViewType.ACCORDION) {
      if (show && icon) {
        this.showAccordionIcon = show;
        this.accordionIconClass = `eva-3-icon-${icon}`;
      }
      this.isFullRoundedAccordion = isFullRounded;
    }

    if (this.openPanelIndex !== null) {
      const initialTab = this.module.data.tabs[this.openPanelIndex];
      if (initialTab?.ajax) {
        this.loadLazyTab(this.openPanelIndex, initialTab);
      } else if (this.isFullWidth && this.hasSomeAjaxModule(initialTab.modules)) {
        this.loadAjaxModules(this.openPanelIndex, initialTab.modules);
      }
    }

    if (this.module.data.view_type === ViewType.TAGS) {
      const initialTab = this.module.data.tabs[this.selectedIndex];
      if (initialTab?.ajax) {
        this.loadLazyTab(this.selectedIndex, initialTab);
      }
    }

    this.module.data.tabs.forEach((tab, index) => { this.updateModules(tab.modules, index) });
    this.textPosition = this.module.text_position ?? TextPosition.TOP;
    this.checkBackground();
  }

  checkBackground() {
    this.hasBackground = !!(
      this.module.background_module &&
      (
        this.module.background_module.image ||
        this.module.background_module.color
      )
    );
  }

  resolveOpenPanelIndex() {
    if (this.module.data?.selected_tab_index !== undefined) {
      return this.module.data.selected_tab_index;
    } else {
      return (this.module.data.view_type === this.viewType.TABS || !this.module.data.view_type) ? 0 : null;
    }
  }

  hasSomeAjaxModule(modules: Module[]) {
    return modules.find(module => module.ajax);
  }

  updateModules(modules: Module<any>[], index: number): Module<any>[] {
    if (!modules) {
      return modules;
    }
    this.emptyStateService.analyzeEmptyStates(modules, this.getContainerId(index));
    modules.forEach((module) => module.row_number = this.module.row_number)
    return modules;
  }

  getContainerId(index: number): string {
    return this.module.unique_id + '-tab-' + index;
  }

  async tabSelected(tab: TabSelected) {
    this.trackSelection(tab.name, tab.index, UpaTarget.TAB);

    const selectedTab = this.module.data.tabs[tab.index];
    if (selectedTab.ajax) {
      await this.loadLazyTab(tab.index, selectedTab);
    } else if (this.hasSomeAjaxModule(selectedTab.modules)) {
      await this.loadAjaxModules(tab.index, selectedTab.modules);
    }
  }

  tagSelected(index: number): void {
    this.selectedIndex = index;

    const label = this.module.data.tabs[index]?.title_tab ?? `tag-${index}`;
    this.trackSelection(label, index, UpaTarget.TAG);
    this.scrollTagIntoView(index);

    const selectedTab = this.module.data.tabs[index];
    if (selectedTab?.ajax) {
      this.loadLazyTab(index, selectedTab);
    }
  }

  accordionSelected(index: number): void {
    const wasOpen = this.openPanelIndex === index;

    this.openPanelIndex = wasOpen ? null : index;

    const label = this.module.data.tabs[index]?.title_tab ?? `accordion-${index}`;
    if (!wasOpen) {
      this.trackSelection(label, index, UpaTarget.ACCORDION);

      const selectedTab = this.module.data.tabs[index];
      if (selectedTab?.ajax) {
        this.loadLazyTab(index, selectedTab);
      }
    } else {
      const closedLabel = `close-${label}`;
      this.trackSelection(closedLabel, index, UpaTarget.ACCORDION);
    }
  }

  private trackSelection(label: string, index: number, target: UpaTarget): void {
    this.upaService.trackClickTopic({
      label,
      positionIndex: index,
      moduleId: this.module.id,
      moduleIndex: this.module.position,
      target,
      uniqueId: this.module.unique_id
    });
  }

  async loadLazyTab(tabIndex: number, tab: Tab): Promise<void> {
    if (this.ajaxModulesByTab[tabIndex] !== undefined) {
      return;
    }
    if (this.loadingModules[tabIndex]) {
      return;
    }

    const modulesIds = tab.module_ids;
    const upaData = window.upaData;
    const domain = upaData.dn.replace(/:\d+/, '');

    this.loadingModules[tabIndex] = true;
    try {
      const modulesResponse = await this.headlessModuleService.getModulesFromLanding({
        locale: this.locale,
        domain,
        tripStatus: upaData.trip_status,
        socialId: upaData.despegarid,
        trackerId: upaData.userid,
        modulesIds: modulesIds,
        landingId: upaData.lname,
        tripPlannerId: this.module.data.trip_planner_id,
        linaId: this.module.data.lina_id,
        channel: upaData.ch,
        groupedModuleId: this.module.unique_id
      });
      this.ajaxModulesByTab[tabIndex] = this.updateModules(modulesResponse, tabIndex);
    } catch (error) {
      console.error(`[GroupedModules] Failed to load lazy tab modules (tab=${tabIndex}, moduleId=${this.module.unique_id})`, error);
    } finally {
      this.loadingModules[tabIndex] = false;
    }
  }

  async loadAjaxModules(tabIndex: number, modules: Module[]) {
    if (this.ajaxModulesByTab[tabIndex] !== undefined || this.loadingModules[tabIndex]) {
      return; // No volver a cargar los módulos si ya han sido cargados o están cargando
    }

    this.loadingModules[tabIndex] = true;
    try {
      const sharedModulesIds = modules.map(module => module.unique_id).filter((id): id is string => id !== undefined);
      const upaData = window.upaData;
      const domain = upaData.dn.replace(/:\d+/, '');
      const modulesResponse = await this.headlessModuleService.getModules({
        locale: this.locale,
        domain,
        tripStatus: upaData.trip_status,
        socialId: upaData.despegarid,
        trackerId: upaData.userid,
        sharedModuleIds: sharedModulesIds,
        tripPlannerId: this.module.data.trip_planner_id,
        linaId: this.module.data.lina_id,
        channel: upaData.ch
      });
      this.ajaxModulesByTab[tabIndex] = this.updateModules(modulesResponse, tabIndex);
    } catch (error) {
      console.error(`[GroupedModules] loadAjaxModules - headless module request failed (tab=${tabIndex}, moduleId=${this.module.unique_id})`, error);
    } finally {
      this.loadingModules[tabIndex] = false;
    }
  }

  buildTagButtonOptions(label: string, isActive: boolean): ButtonOptions {
    const variant = this.module?.data?.options?.variant ?? 'DEFAULT';

    let ghost_button;
    let type;

    switch (variant) {
      case 'LIGHTEN':
        ghost_button = !isActive;
        type = isActive ? '-white' : '-lighten';
        break;
      case 'LINK':
        ghost_button = false;
        type = isActive ? '-primary' : '-link';
        break;
      case 'DEFAULT':
      default:
        ghost_button = true;
        type = isActive ? '' : '-darken';
        break;
    }

    return {
      ghost_button: ghost_button,
      size: '-md',
      type: type,
      link_text: label,
      as_span: true,
      stop_propagation: true
    };
  }

  private scrollTagIntoView(index: number): void {
    const listEl = this.tagsListRef?.nativeElement;
    const itemEl = this.tagItemRefs?.get(index)?.nativeElement;

    if (!listEl || !itemEl) return;

    requestAnimationFrame(() => {
      const padding = 16;

      // posición del elemento dentro del contenedor
      const itemLeft = itemEl.offsetLeft;
      const itemRight = itemLeft + itemEl.offsetWidth;

      // area visible del contenedor scrolleable
      const visibleLeft = listEl.scrollLeft;
      const visibleRight = visibleLeft + listEl.clientWidth;

      // Si se sale por la izquierda
      if (itemLeft < visibleLeft + padding) {
        listEl.scrollTo({
          left: Math.max(0, itemLeft - padding),
          behavior: 'smooth'
        });
        return;
      }

      // Si se sale por la derecha
      if (itemRight > visibleRight - padding) {
        const nextLeft = itemRight - listEl.clientWidth + padding;
        listEl.scrollTo({
          left: Math.max(0, nextLeft),
          behavior: 'smooth'
        });
      }
    });
  }

  get isDesktop(): boolean {
    return this.screenType === ScreenType.DESKTOP;
  }
}
